import React from 'react';

interface IllustrationBannerProps {
    src: string;
    alt?: string;
}

export const IllustrationBanner = ({ src, alt = '' }: IllustrationBannerProps) => (
    <div className="tw-flex tw-justify-center tw-mb-24 tw-p-16 tw-bg-white tw-border tw-rounded dark:tw-bg-neutral-inverse">
        <img src={src} alt={alt} className="tw-h-[120px]" />
    </div>
);
